<template>
    <div class="editBg">
        <img src="/static/images/close.png" class="popClose" @click="hidePop">
        <div class="editTit"> {{ type == 0 ? '编辑固定区域' : '编辑提取区域' }}</div>
        <div class="tools">


            <div class="tabll" v-if="segState == 1">
                <button class="bigBtn " @click="resetShape" style="margin-right: 0.0921rem;">
                    <img class="smicon" src="/static/images/seg_chongzhi.png" />
                    重置</button>

                <button class="bigBtn " @click="backDraw" style="margin-right: 0.0921rem;">
                    <img class="smicon" src="/static/images/seg_chexiao.png" />
                    撤销</button>













            </div>

        </div>
        <div class="root">
            <div class="canvasRoot" ref="root">
                <div v-if="segState == 0" class="segProgress">
                    <img class="pic_progress" src="/static/images/seg_progress.gif" />
                    AI正在解析图片中...

                </div>
                <div v-if="segState == 5" class="segFail">
                    <img class="pic_progress" src="/static/images/seg_fail.png" />
                    <button class="failBtn" @click="reChange">重新解析</button>
                </div>
                <canvas v-show="segState == 1" ref="canvas" class="canvas" @mousedown.stop="startDrawing"
                    @mousemove="drawShape" @mouseup="endDrawing" @touchstart.stop.prevent="startDrawing"
                    @touchmove.stop.prevent="drawShape" @touchend="endDrawing"></canvas>

            </div>
            <button class="pic2btn" @click="makeSegMask">
                <span>{{ type == 0 ? '生成蒙版' : '预览选区' }} </span>
                <img src="/static/images/pic2text.png"
                    style="width: 0.1146rem ;height: 0.1042rem; margin-left: 0.0521rem;">
            </button>
            <!-- <button class="pic2btn" @click="makeMatting">
                <span>抠图测试</span>
                <img src="/static/images/pic2text.png"
                    style="width: 0.1146rem ;height: 0.1042rem; margin-left: 0.0521rem;">
            </button> -->
            <div class="canvasRoot">
                <div v-show="maskState == -1" class="placeMask">
                    {{ type == 0 ? '蒙版结果将在此处展示' : '预览结果将在此处展示' }}

                </div>
                <div v-show="maskState == 5" class="segFail">
                    <img class="pic_progress" src="/static/images/seg_fail.png" />
                    <button class="failBtn" @click="makeSegMask">重新生成</button>
                </div>

                <div v-show="maskState == 0" class="segProgress">
                    <img class="pic_progress" src="/static/images/seg_progress.gif" />
                    加载中。。
                </div>
                <img v-show="maskState == 1" :src="maskUrl" alt="" class="maskImg">
            </div>

        </div>
        <div class="bot">


            <el-input v-if="type == 0" class="input" type="textarea" :autosize="{ minRows: 5, maxRows: 5 }"
                @input="removeNewlines" placeholder="写下你的创意" v-model="propMsg" resize="none" @keyup.enter.native="send">
            </el-input>
            <div class="sendBtn" @click="makeTask" v-if="maskUrl">{{ type == 0 ? '一键生成' : '一键提取' }}</div>

        </div>



    </div>
</template>

<script>
import { upload } from '@/utils/upload'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'

import { sdSegTask as mjChatStream, splitImage as send, splitImageForPoint as makeMask, mattingImage } from '@/api/ai/sdService'
export default {
    data() {
        return {
            isDrawing: false,
            loadImgSuccess: false,
            canvas: null,
            context: null,
            showEdit: true,
            startCoords: { x: 0, y: 0 },
            shapeCoords: [],
            imgSrcWidth: null,
            imgSrcHeight: null,
            imgSrc: null,
            bgImg: null,
            sessionHash: null,
            fillShapeEnd: false,
            pathShapeList: [],
            curTool: 'stroke',
            curPath: null,
            pointList: [],
            stokeWidth: 2,
            maskUrl: null,
            propMsg: null,
            segState: 0,
            maskState: -1,
            maskImgUrl: null,
            segImageUrl: null,
            offSrceenCanvas: null,
            offScreenContext: null,
            pointSelectImg: null,
            type: 0




        }
    },


    // 添加点  
    computed: {
        showTip() {
            return !this.isDrawing && this.loadImgSuccess && !this.fillShapeEnd
        }
    },


    // 初始化 进入 
    methods: {
        makeMatting() {
            const obj = {}
            obj.url = this.imgSrc
            obj.selectSplitUrl = this.maskImgUrl
            obj.width = this.imgSrcWidth
            obj.height = this.imgSrcHeight
            obj.splitImage = this.segImageUrl
            obj.selectMask = this.maskUrl
            mattingImage(obj)
        },

        async doSegment() {
            // 获取到图片宽高信息后执行 
            this.segState = 0
            this.sessionHash = uuidv4()
            const response = await axios.get(
                this.imgSrc + '?imageInfo&t=' + new Date().getTime())
            if (response.status == '200') {
                this.imgSrcWidth = response.data.width
                this.imgSrcHeight = response.data.height
                // 处理图片尺寸问题
                const arr = [this.imgSrcWidth, this.imgSrcHeight]

                if (Number.parseInt(arr[0]) > Number.parseInt(arr[1])) {
                    const scale = (arr[1] / arr[0]).toFixed(2)
                    console.log(scale)
                    this.canvas.width = this.$refs.root.clientWidth
                    this.canvas.height = this.$refs.root.clientWidth * scale
                } else if (Number.parseInt(arr[0]) < Number.parseInt(arr[1])) {
                    const scale = (arr[0] / arr[1]).toFixed(2)
                    console.log(scale)
                    this.canvas.width = this.$refs.root.clientWidth * scale
                    this.canvas.height = this.$refs.root.clientWidth
                } else {
                    this.canvas.width = this.$refs.root.clientWidth
                    this.canvas.height = this.$refs.root.clientWidth
                }
                console.log(arr)
                this.offSrceenCanvas.width = this.canvas.width
                this.offSrceenCanvas.height = this.canvas.height

                // 解开 直接显示图片
                // this.context.fillStyle = '#999999'
                // this.context.fillRect(0, 0, this.canvas.width, this.canvas.height)
                // this.mockImgDone(this.imgSrc)
                const params = {
                    url: this.imgSrc,
                    blackUrl: this.blackUrl,
                    msgKey: this.sessionHash
                }
                send(params).then(res => {
                    console.log('发送成功 dosegment')
                    const curHash = this.sessionHash
                    setTimeout(() => {
                        if (curHash == this.sessionHash && this.segState == 0
                        ) {
                            // 没有新生成 状态还在进行中,界面还在打开状态
                            this.segState = 5
                            console.log(' fail split')
                        } else {
                            console.log(' done split')
                        }
                    }, 50 * 3 * 1000)
                }).catch(e => {
                    this.segState = 5
                })


            }




        },
        // 增加一步  首先移除掉背景 再上传图片
        async doSegmentForRemoveBg() {

            // 获取到图片宽高信息后执行 
            this.segState = 0
            this.sessionHash = uuidv4()
            const response = await axios.get(
                this.imgSrc + '?imageInfo&t=' + new Date().getTime())
            if (response.status == '200') {
                this.imgSrcWidth = response.data.width
                this.imgSrcHeight = response.data.height
                // 处理图片尺寸问题
                const arr = [this.imgSrcWidth, this.imgSrcHeight]

                if (Number.parseInt(arr[0]) > Number.parseInt(arr[1])) {
                    const scale = (arr[1] / arr[0]).toFixed(2)
                    console.log(scale)
                    this.canvas.width = this.$refs.root.clientWidth
                    this.canvas.height = this.$refs.root.clientWidth * scale
                } else if (Number.parseInt(arr[0]) < Number.parseInt(arr[1])) {
                    const scale = (arr[0] / arr[1]).toFixed(2)
                    console.log(scale)
                    this.canvas.width = this.$refs.root.clientWidth * scale
                    this.canvas.height = this.$refs.root.clientWidth
                } else {
                    this.canvas.width = this.$refs.root.clientWidth
                    this.canvas.height = this.$refs.root.clientWidth
                }
                console.log(arr)
                this.offSrceenCanvas.width = this.canvas.width
                this.offSrceenCanvas.height = this.canvas.height

                // 解开 直接显示图片
                // this.context.fillStyle = '#999999'
                // this.context.fillRect(0, 0, this.canvas.width, this.canvas.height)
                // this.mockImgDone(this.imgSrc)
                const params = {
                    url: this.imgSrc,
                    blackUrl: this.blackUrl,
                    msgKey: this.sessionHash
                }
                send(params).then(res => {
                    console.log('发送成功 dosegment')
                    const curHash = this.sessionHash
                    setTimeout(() => {
                        if (curHash == this.sessionHash && this.segState == 0
                        ) {
                            // 没有新生成 状态还在进行中,界面还在打开状态
                            this.segState = 5
                            console.log(' fail split')
                        } else {
                            console.log(' done split')
                        }
                    }, 50 * 3 * 1000)
                }).catch(e => {
                    this.segState = 5
                })


            }




        },



        onSegMsgSend(data) {
            const status = data.status
            if (status == 'SUCCESS') {
                if (!data.msgKey) {
                    return
                }
                if (data.msgKey == this.sessionHash) {
                    if (data.splitImageUrl) {

                        // 四分图成功 展示四分图 切换状态
                        this.segState = 1
                        this.segImageUrl = data.splitImageUrl
                        this.resetShape()
                    }
                    if (data.selectSplitUrl) {
                        // 等待蒙版图完成后 在显示
                        this.maskImgUrl = data.selectSplitUrl
                    }
                    if (data.maskUrl) {
                        this.maskState = 1
                        this.maskUrl = data.maskUrl
                    }
                } else {
                    console.log('msg is useless' + data.msg)
                }

            } else {
                //
                this.$message(data.msg)
            }
        },
        mjcon() {
            // 区分命令
            const eventSource = mjChatStream(
                data => {

                    const status = data.status
                    if (status == 'SUCCESS') {
                        if (!data.msgKey) {
                            return
                        }
                        if (data.msgKey == this.sessionHash) {
                            if (data.splitImageUrl) {

                                // 四分图成功 展示四分图 切换状态
                                this.segState = 1
                                this.segImageUrl = data.splitImageUrl
                                this.resetShape()
                            }

                            if (data.maskUrl) {
                                this.maskState = 1
                                this.maskUrl = data.maskUrl
                            }
                        } else {
                            console.log('msg is useless' + data.msg)
                        }

                    } else {
                        //
                        this.$message(data.msg)
                    }

                    this.recontime = 0








                },
                close => {
                    // 延迟1s重连
                    if (
                        !eventSource.__CLOSED &&
                        (!this.recontime || this.recontime < 10)
                    ) {
                        setTimeout(() => {
                            if (this.recontime) {
                                this.recontime++
                            } else {
                                this.recontime = 1
                            }
                            this.mjcon()
                        }, 1000 * this.recontime)
                    }
                },

                err => {
                    if (
                        !eventSource.__CLOSED &&
                        (!this.recontime || this.recontime < 10)
                    ) {
                        setTimeout(() => {
                            if (this.recontime) {
                                this.recontime++
                            } else {
                                this.recontime = 1
                            }
                            this.mjcon()
                        }, 1000 * this.recontime)
                    }
                }
            )
            this.mjEventSource = eventSource

        },
        removeNewlines() {
            // 去除输入内容中的换行符
            this.propMsg = this.propMsg.replace(/[\r\n]+/g, '')
        },




        floodFill(x, y, newColorRGBA, ctx, canvas) {
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
            const data = new Uint32Array(imageData.data.buffer)
            const targetColor = data[y * canvas.width + x]
            const newColor = newColorRGBA // 假设这是一个 32 位的颜色值

            const stack = [{ x, y }]

            while (stack.length > 0) {
                const { x, y } = stack.pop()
                const currentIndex = y * canvas.width + x
                const currentColor = data[currentIndex]

                // 检查颜色是否与目标颜色相同
                if (currentColor === targetColor) {
                    data[currentIndex] = newColor // 设置新颜色

                    // 将相邻的点加入栈中
                    const positions = [[x - 1, y], [x + 1, y], [x, y - 1], [x, y + 1]]
                    for (const [nx, ny] of positions) {
                        if (nx >= 0 && nx < canvas.width && ny >= 0 && ny < canvas.height) {
                            stack.push({ x: nx, y: ny })
                        }
                    }
                }
            }

            ctx.putImageData(imageData, 0, 0)
        },












        // 变换点(75, 50) 周围的绿色区域为蓝色
        backDraw() {

            if (this.pointList.length == 0) {
                return
            }

            this.loadImgSuccess = false
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
            this.showEdit = true
            const image = new Image()
            const bgImg = new Image()
            bgImg.src = this.imgSrc
            image.crossOrigin = 'anonymous'
            image.src = this.segImageUrl // 替换成你的图片URL




            image.onload = () => {

                //  this.canvas.width = image.width
                // this.canvas.height = image.height
                // this.canvas.width = this.$refs.root.clientWidth
                // this.canvas.height = this.$refs.root.clientWidth
                // console.log(this.canvas.width + 'fff   ' + this.canvas.height)
                this.context.drawImage(image, 0, 0, image.width, image.height, 0, 0, this.canvas.width, this.canvas.height)
                this.loadImgSuccess = true
                console.log(this.pointList.length)
                this.pointList.splice(this.pointList.length - 1, 1)

                // 重新画图
                this.context.strokeStyle = 'black'
                this.context.fillStyle = 'black'
                // this.context.globalCompositeOperation = 'source-atop'
                for (const cp of this.pointList) {
                    console.log(cp)
                    this.context.lineWidth = cp.w * 2
                    this.context.lineJoin = 'round'
                    this.context.lineCap = 'round'
                    this.context.beginPath()
                    this.context.moveTo(cp.x, cp.y)
                    this.context.arc(cp.x, cp.y, cp.w, 0, Math.PI * 2)
                    this.context.stroke()
                    console.log('ffff' + cp)

                }
            }

            image.onerror = () => {
                // this.$message('图片加载失败')

            }



        },
        reMakeSegMask() {
            this.maskState = 0
            this.maskImgUrl = null
            this.maskUrl = null
            this.doSendMask(this.pointSelectImg)
        },

        makeSegMask() {
            // 导出图片 
            if (this.segState != 1) {
                this.$message('分割图还未生成 请等待分割图生成完成')
                return
            }
            if (this.maskState == 0) {
                this.$message('蒙版生成中 请等待生成完成')
                return
            }
            if (this.pointList.length == 0) {
                this.$message('请选择蒙版区域')
                return
            }
            // todo
            this.exportImage()
            this.maskState = 0
            this.maskImgUrl = null
            this.maskUrl = null

        },

        getPixelColor(canvas, x, y) {
            // 获取画布的2D渲染上下文
            const ctx = canvas.getContext('2d')

            // 检查坐标是否在画布范围内
            if (x < 0 || x >= canvas.width || y < 0 || y >= canvas.height) {
                return null // 或者抛出一个错误
            }

            // 创建一个ImageData对象，它只包含一个像素的数据
            const imageData = ctx.getImageData(x, y, 1, 1)

            // imageData.data是一个Uint8ClampedArray，它包含4个元素，分别代表R, G, B, A通道的值
            const pixelData = imageData.data

            // 返回一个包含RGBA值的数组
            return [pixelData[0], pixelData[1], pixelData[2], pixelData[3]]
        },



        changeImg(str, type) {


            // 开始执行分割任务图片
            //  str = 'https://7niu.ztxin.cn/ai/xiniao/user/21714098074837693J9FPJIn/1714098074837.png'
            this.segState = 0
            this.type = type
            //  console.log('fffffs s  ' + str)

            this.imgSrc = str
            this.doSegment()
            // 获取图片的真实高度
            //    this.pathShapeList = []




        },
        reChange() {

            this.doSegment()
        },
        hidePop() {
            this.isDrawing = false
            this.$emit('hidePop')
        },
        resetShape() {
            // this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
            this.loadImage()
            this.pathShapeList = []
            this.pointList = []

        },
        loadImage() {
            this.loadImgSuccess = false
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
            this.offScreenContext.clearRect(0, 0, this, this.offSrceenCanvas.width, this.offSrceenCanvas.height)
            this.showEdit = true
            const image = new Image()
            const bgImg = new Image()
            bgImg.crossOrigin = 'anonymous'
            bgImg.src = this.imgSrc
            image.crossOrigin = 'anonymous'
            image.src = this.segImageUrl // 替换成你的图片URL




            image.onload = () => {

                //  this.canvas.width = image.width
                // this.canvas.height = image.height
                // this.canvas.width = this.$refs.root.clientWidth
                // this.canvas.height = this.$refs.root.clientWidth
                //  console.log(this.canvas.width + 'fff   ' + this.canvas.height)

                this.context.drawImage(image, 0, 0, image.width, image.height, 0, 0, this.canvas.width, this.canvas.height)
                console.log(this.context)
                console.log(this.offScreenContext)
                this.offScreenContext.drawImage(image, 0, 0, image.width, image.height, 0, 0, this.canvas.width, this.canvas.height)
                this.loadImgSuccess = true
                // this.$message('图片加载d')
            }

            image.onerror = () => {
                this.$message('图片加载失败')
            }
        },





        startDrawing(event) {

            if (event.offsetX == undefined) {
                console.log(this.$refs.canvas)
                const imgTop = this.$refs.canvas.getBoundingClientRect().top
                const imgLeft = this.$refs.canvas.getBoundingClientRect().left
                event.offsetX = event.changedTouches[0].pageX - imgLeft
                event.offsetY = event.changedTouches[0].pageY - imgTop




            }

            this.isDrawing = true
            const { offsetX, offsetY } = event
            this.lastX = offsetX
            this.lastY = offsetY


            const ctx = this.context
            const offctx = this.offScreenContext
            ctx.beginPath()
            ctx.moveTo(this.lastX, this.lastY)
            offctx.beginPath()
            offctx.moveTo(this.lastX, this.lastY)
            this.curPath = {

            }
            this.curPath.path = []
            this.curPath.path.push({ x: this.lastX, y: this.lastY })


            // ------开始添加点 
            ctx.lineWidth = this.stokeWidth
            offctx.lineWidth = this.stokeWidth
            //  ctx.lineTo(offsetX + 1, offsetY + 1)
            this.curPath.stokeWidth = this.stokeWidth
            this.curPath.isFill = this.curTool === 'fill'
            //  this.curPath.path.push({ x: offsetX, y: offsetY })
            // this.drawPath.push({ offsetX, offsetY })
            ctx.strokeStyle = 'black' // 设置涂鸦颜色
            ctx.fillStyle = 'black'


            // 要和当点颜色相同




            offctx.strokeStyle = 'black' // 设置涂鸦颜色
            offctx.fillStyle = 'black'
            ctx.arc(this.lastX, this.lastY, this.stokeWidth / 2, 0, Math.PI * 2) // 创建一个圆形，半径为5
            offctx.arc(this.lastX, this.lastY, this.stokeWidth / 2, 0, Math.PI * 2)
            this.pointList.push({
                x: this.lastX,
                y: this.lastY,
                w: this.stokeWidth / 2
            })




            ctx.stroke()
            offctx.stroke()



        },
        makeTask() {

            console.log(this.maskState)
            console.log(this.maskUrl)
            if (this.maskState != 1 || !this.maskUrl) {
                this.$message('请等待蒙层处理')
                return
            }

            //  debugger
            if (
                (this.propMsg && !/^[^\da-zA-Z\u4e00-\u9fa5]+$/u.test(this.propMsg)) || this.type == 1
            ) {
                const w = this.imgSrcWidth
                const h = this.imgSrcHeight
                if (w > h) {

                    this.restWidth = 1024
                    this.restHeight = Math.floor(1024 * (h / w))

                } else if (w < h) {
                    this.restHeight = 1024
                    this.restWidth = Math.floor(1024 * (w / h))
                } else {
                    this.restWidth = this.restHeight = 1024
                }
                const obj = {
                    maskUrl: this.maskUrl,
                    imgSrc: this.imgSrc,
                    width: this.restWidth,
                    height: this.restHeight,
                    splitImage: this.segImageUrl,
                    selectMask: this.pointSelectImg
                }
                if (this.type == 0) {
                    obj.propMsg = this.propMsg
                }

                this.$emit('exportImg1', obj)
            } else {
                this.$message('请输入提示词')
            }

        },
        makeTask1() {
            // for (const ppt of this.pointList) {

            //     this.floodFill(ppt.x + 5, ppt.y + 5, 0xffffffff, this.offScreenContext, this.offSrceenCanvas)
            // }
            const image = this.offSrceenCanvas.toDataURL('image/png')
            const a = document.createElement('a')

            a.href = image
            a.download = 'exported_image.png'
            a.click()
            // console.log('bbbbbbbbbbbbbb')
            // 绘制大图片

        },


        mockImgDone(str) {
            this.segState = 1
            this.segImageUrl = str
            this.resetShape()
        },
        drawShape(event) {
            if (!this.isDrawing) return
            if (event) {
                return
            }
            if (event.offsetX == undefined) {
                const imgTop = this.$refs.canvas.getBoundingClientRect().top
                const imgLeft = this.$refs.canvas.getBoundingClientRect().left
                event.offsetX = event.changedTouches[0].pageX - imgLeft
                event.offsetY = event.changedTouches[0].pageY - imgTop




            }


            const { offsetX, offsetY } = event
            const ctx = this.context
            ctx.strokeStyle = 'black' // 设置涂鸦颜色
            ctx.fillStyle = 'black'
            ctx.lineWidth = this.stokeWidth // 设置涂鸦笔触宽度
            if (this.curTool === 'fill') {
                ctx.lineWidth = 2
            }
            ctx.lineJoin = 'round'
            ctx.lineCap = 'round'

            ctx.moveTo(this.lastX, this.lastY)
            ctx.lineTo(offsetX, offsetY)
            this.curPath.stokeWidth = this.stokeWidth
            this.curPath.isFill = this.curTool === 'fill'
            this.curPath.path.push({ x: offsetX, y: offsetY })
            // this.drawPath.push({ offsetX, offsetY })

            if (this.curTool === 'fill') {
                const startXy = this.curPath.path[0]
                ctx.lineTo(startXy.x, startXy.y)
                ctx.fill()
                ctx.closePath()
            }

            ctx.stroke()
            // this.fillShape()
            this.lastX = offsetX
            this.lastY = offsetY
        },
        endDrawing() {

            this.isDrawing = false
            if (!this.isDrawing) {
                return
            }
            this.pathShapeList.push(this.curPath)

        },
        resetBuildImgSize(w, h) {
            // 336  328
            if (w > h) {

                this.restWidth = 1024
                this.restHeight = Math.floor(1024 * (h / w))

            } else if (w < h) {
                this.restHeight = 1024
                this.restWidth = Math.floor(1024 * (w / h))
            } else {
                this.restWidth = this.restHeight = 1024
            }


        },
        draw() {
            this.context.strokeStyle = 'red'
            this.context.lineWidth = 2

            this.context.beginPath()
            // this.context.lineTo(this.startCoords.x, this.startCoords.y)

            for (let i = 0; i < this.shapeCoords.length - 1; i++) {
                const x = (this.shapeCoords[i].x + this.shapeCoords[i + 1].x) / 2
                const y = (this.shapeCoords[i].y + this.shapeCoords[i + 1].y) / 2
                this.context.quadraticCurveTo(this.shapeCoords[i].x, this.shapeCoords[i].y, x, y)
            }

            // 连接最后一个点和第一个点形成封闭图形
            // const x = (this.shapeCoords[this.shapeCoords.length - 1].x + this.startCoords.x) / 2
            // const y = (this.shapeCoords[this.shapeCoords.length - 1].y + this.startCoords.y) / 2
            // this.context.quadraticCurveTo(this.shapeCoords[this.shapeCoords.length - 1].x, this.shapeCoords[this.shapeCoords.length - 1].y, x, y)

            // this.context.globalAlpha = 0.01
            this.context.closePath()
            // this.context.stroke()
            // this.context.save()
            // this.context.clip()
            // this.context.drawImage(this.bgImg, 0, 0, this.canvas.width, this.canvas.height)
            // this.context.restore()
            // this.context.globalAlpha = 1
        },

        // 透明图片



        // 黑底白图
        exportImage() {
            // 生成记录 
            // 重绘记录的图片
            if (this.pointList.length == 0) {
                this.$message({ type: 'error', message: '请选择重绘区域' })
                return
            }

            // 传递点 就够了 
            console.log(this.pointList)
            const scale = (Math.max(this.imgSrcWidth, this.imgSrcHeight
            )) / (Math.max(this.canvas.width, this.canvas.height))
            console.log(scale + ' gggggggg  ')
            const points = []
            for (const p of this.pointList) {
                points.push([Math.floor(p.x * scale), Math.floor(p.y * scale)])
            }
            const params = {
                url: this.imgSrc,
                selectPoints: points,
                msgKey: this.sessionHash
            }
            makeMask(params).then(res => {
                console.log('发送成功 dosegment')
                const curHash = this.sessionHash
                setTimeout(() => {
                    if (curHash == this.sessionHash && this.segState == 0
                    ) {
                        // 没有新生成 状态还在进行中,界面还在打开状态
                        this.segState = 5
                        console.log(' fail split')
                    } else {
                        console.log(' done split')
                    }
                }, 50 * 3 * 1000)
            }).catch(e => {
                this.segState = 5
            })





        },









        doSendMask(res) {
            const paramsObj = {
                url: this.imgSrc,
                splitImage: this.segImageUrl,
                selectMask: res,
                width: this.imgSrcWidth,
                height: this.imgSrcHeight,
                msgKey: this.sessionHash


            }
            makeMask(paramsObj).then(res => {
                const curHash = this.sessionHash
                setTimeout(() => {
                    if (curHash == this.sessionHash && this.maskState == 0
                    ) {
                        // 没有新生成 状态还在进行中,界面还在打开状态
                        this.maskState = 5
                        console.log(' fail split')
                    } else {
                        console.log(' done split')
                    }
                }, 50 * 3 * 1000)
            }).catch(e => {
                this.maskState = 5
            })

        },
        dataURItoBlob(dataURI) {
            const byteString = atob(dataURI.split(',')[1])
            const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

            const arrayBuffer = new ArrayBuffer(byteString.length)
            const uint8Array = new Uint8Array(arrayBuffer)

            for (let i = 0; i < byteString.length; i++) {
                uint8Array[i] = byteString.charCodeAt(i)
            }

            return new Blob([arrayBuffer], { type: mimeString })
        },
        send() { }

    },
    mounted() {

        this.sessionHash = uuidv4()
        this.canvas = this.$refs.canvas
        this.context = this.canvas.getContext('2d')
        this.offSrceenCanvas = document.createElement('canvas')
        this.offScreenContext = this.offSrceenCanvas.getContext('2d')
        console.log(this.offScreenContext)
        console.log(this.offSrceenCanvas)
        // this.mjcon()


    },
    beforeDestroy() {
        // if (this.mjEventSource) {
        //     this.mjEventSource.close()
        // }
    }



}
</script>

<style scoped>
canvas {
    cursor: crosshair;



}

.pic_progress {

    background-size: 100% 100%;
    width: 200px;
    height: 200px;


}

.sendBtn {
    width: 163px;
    height: 50px;
    background: #03AFF4;
    border-radius: 10px;
    position: absolute;
    font-size: 18px;
    right: 120px;
    color: #fff;
    top: (50% - 50px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.tools {
    display: flex;
    margin-left: 20px;
    width: 100%;
    padding-left: 16%;
    justify-content: flex-start;
    padding-bottom: 30px;
}

.failBtn {
    outline: none;
    margin: 0;
    padding: 0;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    border: 1px solid #03AFF4;
    color: #03A8F4;
    font-size: 20px;
    color: #03A8F4;
    line-height: 28px;
    margin-top: 60px;
    padding: 10px
}


.placeMask {
    background-size: 100% 100%;
    background-image: url('/static/images/masaikebg.png');
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}






.tools button {
    border: 1px solid #545C6F;
    border-radius: 8px;
    margin-left: 14px;
    outline: none;
    background: none;
    margin: 0;
    padding: 0;
    color: #fff;
    font-size: 14px;
}

.pic2btn {
    width: 144px;
    margin-left: 20px;
    margin-right: 20px;
    height: 56px;
    background: #06CAF9;
    border-radius: 12px;
    display: flex;
    color: #fff;
    line-height: 56px;
    outline: none;
    border: none;
    font-size: 16px;
    justify-content: center;
    align-items: center;
}

.segProgress {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 14px;
}

.segFail {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 14px;
    background: #272727;
    border-radius: 10px;

}

.segFail img {
    width: 100px;
    height: 100px;
}

/* .canvas {
    width: 100%;
    height: 100%;
} */

.popClose {
    position: absolute;
    right: 30px;
    top: 14px;
    width: 18px;
    height: 18px;
}

.sliderBar {
    width: 70px;
    margin-left: 8px;
    margin-right: 8px;
}

.input {
    width: 88%;
    height: 116px;
    background: #1A1F32;
    border-radius: 10px;
    position: relative;
}

.editTit {
    font-size: 20px;
    color: #fff;

    margin-top: 10px;
    margin-bottom: 26px;

}

.resetBtn {
    border-radius: 10px;
    border: 1px solid rgba(19, 203, 248, 1);
    width: 180px;
    height: 54px;
    color: #fff;
    font-size: 16px;


}

.smicon {
    width: 14px;
    height: 14px;
    margin-right: 4px;
}


.setBtn {
    width: 180px;
    height: 54px;
    background: #06CAF9;
    border-radius: 10px;
    color: #fff;
    font-size: 16px;
}



.widthIndex {
    width: 43px;
    height: 30px;
    background: #272D40;
    border-radius: 8px;
    text-align: center;
    color: #fff;
    margin-left: 10px;
    margin-right: 10px;
    font-size: 14px;
    line-height: 30px;
}

.tabll {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 12px;
    color: #AAB2C2;
    width: 100%;

}

.tip {
    padding-left: 20px;
    padding-right: 20px;
    color: #fff;
    background: #000;
    border-radius: 20px;
    height: 40px;
    line-height: 40px;
    position: absolute;
    top: 10%;


}

.bigBtn {
    padding-left: 10px;
    padding-right: 10px;
    height: 38px;
    border-radius: 8px;
    width: 85px;
    height: 35px;
    line-height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;


}

.curToolBtn {
    border: 1px solid #00D0FF;
}



.smallTitle {
    color: #ABB2C1;
    font-size: 15px;
    margin-bottom: 8px;
    margin-top: 8px;
    align-self: flex-start;
    width: 100%;
    text-align: left;

}

.bot {
    margin-top: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;
}

.root {
    position: relative;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.maskImg {
    width: 100%;
    height: 100%;
    object-fit: contain;

}

.canvasRoot {
    width: 440px;
    height: 440px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #1A1F32;
    border-radius: 16px;
    color: #fff;
    font-size: 14px;
}

.editBg {
    padding-top: 14px;
    padding-bottom: 20px;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/segmentView/index.vue